import React from 'react';
import { useSEO } from '../hooks/useSEO';
import Navbar from './Navbar';
import FAQ from './FAQ';
import Footer from './Footer';

const FAQPage = () => {
  useSEO({
    title: 'Συχνές Ερωτήσεις - TailClinic',
    description: 'Απαντήσεις στις πιο συχνές ερωτήσεις για το TailClinic, το λογισμικό διαχείρισης κτηνιατρείου. Μάθετε πώς λειτουργεί, τι περιλαμβάνει και πώς να ξεκινήσετε.',
    canonical: 'https://www.tailclinic.gr/faq',
  });

  return (
    <div style={{
      minHeight: '100vh',
      backgroundColor: '#1A202C'
    }}>
      <Navbar />
      <FAQ />
      <Footer />
    </div>
  );
};

export default FAQPage;
